export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Service type',
    },
    cell: {
      type: 'slot',
      name: 'serviceType',
    },
  },
  {
    width: 20,
    header: {
      type: 'text',
      caption: 'Alias',
    },
    cell: {
      type: 'slot',
      name: 'alias',
    },
  },
  {
    width: 20,
    header: {
      type: 'text',
      caption: 'Subject',
    },
    cell: {
      type: 'slot',
      name: 'subject',
    },
  },
  {
    width: 20,
    header: {
      type: 'text',
      caption: 'Message',
    },
    cell: {
      type: 'slot',
      name: 'message',
    },
  },
  {
    width: 15,
    header: {
      type: 'slot',
      name: 'actionHeader',
    },
    cell: {
      type: 'slot',
      name: 'actions',
    },
  },
];
